import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';

import componentStyles from './ghs-provider-card.css.lit';
import '../../base/outline-heading/outline-heading';

/**
 * Provider Card Component.
 * @element ghs-provider-card
 */
@customElement('ghs-provider-card')
export class GhsProviderCard extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  /**
   * Heading
   */
  @property()
  heading: string;

  /**
   * Sub-heading
   */
  @property({ attribute: 'sub-heading' })
  subHeading?: string;

  render(): TemplateResult {
    return html`
      <div class="provider-card">
        <slot name="image"></slot>
        <div class="content">
          <outline-heading class="heading">${this.heading}</outline-heading>
          <div class="sub-heading">${this.subHeading}</div>

          <div class="divider"></div>
          <div class="details">
            <slot name="detail"></slot>
          </div>

          <div class="actions">
            <slot name="action"></slot>
          </div>
        </div>
      </div>
    `;
  }
}
